<section class="tax-invoice-benefit-wrapper">
  <div class="box-container">
    <!-- topic -->
    <div class="benefit-topic">
      <!-- desktop heading  -->
      <div
        class="benefit-topic__heading benefit-topic__heading--desktop color-gray"
        [innerHtml]="'TAX_INVOICE.BENEFIT.HEADING' | translate"
      ></div>

      <!-- tablet heading  -->
      <div
        class="benefit-topic__heading benefit-topic__heading--tablet color-gray"
        [innerHtml]="'TAX_INVOICE.BENEFIT.HEADING_TABLET' | translate"
      ></div>

      <!-- mobile heading  -->
      <div
        class="benefit-topic__heading benefit-topic__heading--mobile color-gray"
        [innerHtml]="'TAX_INVOICE.BENEFIT.HEADING_MOBILE' | translate"
      ></div>

      <div class="benefit-topic__heading-detail desktop" [innerHtml]="'TAX_INVOICE.BENEFIT.DETAIL' | translate"></div>

      <div class="benefit-topic__heading-detail mobile" [innerHtml]="'TAX_INVOICE.BENEFIT.DETAIL_MOBILE' | translate">
      </div>

      <div class="download-app-section desktop">
        <h3 class="download-title">{{ 'TAX_INVOICE.BENEFIT.DOWNLOAD_APP' | translate }}</h3>
        <div class="download-icon-wrapper">
          <a
            href="https://itunes.apple.com/th/app/new-flowaccount/id1454207520"
            rel="nofollow noopener"
            target="_blank"
            aria-label="Donwload IOS"
          >
            <div class="download-icon-wrapper--ios">
              <picture>
                <source srcset="https://flowaccountcdn.com/assets/image/_WebP/app_store.webp" type="image/webp" />
                <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/app store.png" type="image/jpeg" />
                <img
                  src="https://flowaccountcdn.com/assets/image/mobileApp/app store.png"
                  width="100%"
                  height="auto"
                  alt="flowaccount ios application"
                  title=""
                  loading="lazy"
                />
              </picture>
            </div>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.flowaccount.android&hl=th"
            rel="nofollow noopener"
            target="_blank"
            aria-label="Donwload Android"
          >
            <div class="download-icon-wrapper--android">
              <picture>
                <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/android3.webp" type="image/webp" />
                <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/android3.png" type="image/jpeg" />
                <img
                  src="https://flowaccountcdn.com/assets/image/mobileApp/android3.png"
                  width="100%"
                  height="auto"
                  alt="flowaccount ios application"
                  title=""
                  loading="lazy"
                />
              </picture>
            </div>
          </a>

          <!-- Huawei app gallery -->
          <a
            href="https://appgallery.huawei.com/app/C105848487"
            rel="nofollow noopener"
            target="_blank"
            aria-label="Download Huawei app gallery"
          >
            <div class="download-icon-wrapper--gallery">
              <picture>
                <source srcset="https://flowaccountcdn.com/new_landing/image/logo/Huawei.webp" type="image/webp" />
                <source srcset="https://flowaccountcdn.com/new_landing/image/logo/Huawei.png" type="image/jpeg" />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/logo/Huawei.png"
                  width="100%"
                  height="auto"
                  alt="flowaccount Huawei app gallery application"
                  title=""
                  loading="lazy"
                />
              </picture>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- content -->
    <div class="box">
      <!-- 1 -->
      <div class="img-wrapper">
        <picture>
          <source
            srcset="{{
            translate.currentLang === 'th'
              ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section2/section_2_th_v2.webp'
              : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section2/section_2_en_v2.webp'
          }}"
            type="image/webp"
          />
          <img
            src="{{
              translate.currentLang === 'th'
                ? 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section2/section_2_th_v2.png'
                : 'https://flowaccountcdn.com/new_landing/image/functions/tax_invoice/section2/section_2_en_v2.png'
            }}"
            width="100%"
            height="auto"
            loading="lazy"
            class="box__image"
            alt="ทำใบกำกับภาษีออนไลน์"
            title="ทำใบกำกับภาษีออนไลน์"
          />
        </picture>
      </div>

      <!-- 2 -->
      <div class="text-box">
        <div class="text-box__left">
          <ng-container *ngFor="let item of textArrayLeft; let i = index">
            <div class="text-list">
              <p [innerHtml]="'TAX_INVOICE.BENEFIT.TEXT_LEFT.TEXT_' + (i + 1) | translate"></p>
            </div>
          </ng-container>
        </div>

        <div class="text-box__right">
          <ng-container *ngFor="let item of textArrayRight; let i = index">
            <div class="text-list">
              <p [innerHtml]="'TAX_INVOICE.BENEFIT.TEXT_RIGHT.TEXT_' + (i + 1) | translate"></p>
            </div>
          </ng-container>
        </div>
        <div class="download-app-section tablet">
          <h3 class="download-title">{{ 'TAX_INVOICE.BENEFIT.DOWNLOAD_APP' | translate }}</h3>
          <div class="download-icon-wrapper">
            <a
              href="https://itunes.apple.com/th/app/new-flowaccount/id1454207520"
              rel="nofollow noopener"
              target="_blank"
              aria-label="Donwload IOS"
            >
              <div class="download-icon-wrapper--ios">
                <picture>
                  <source srcset="https://flowaccountcdn.com/assets/image/_WebP/app_store.webp" type="image/webp" />
                  <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/app store.png" type="image/jpeg" />
                  <img
                    src="https://flowaccountcdn.com/assets/image/mobileApp/app store.png"
                    width="100%"
                    height="auto"
                    alt="flowaccount ios application"
                    title=""
                    loading="lazy"
                  />
                </picture>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.flowaccount.android&hl=th"
              rel="nofollow noopener"
              target="_blank"
              aria-label="Donwload Android"
            >
              <div class="download-icon-wrapper--android">
                <picture>
                  <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/android3.webp" type="image/webp" />
                  <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/android3.png" type="image/jpeg" />
                  <img
                    src="https://flowaccountcdn.com/assets/image/mobileApp/android3.png"
                    width="100%"
                    height="auto"
                    alt="flowaccount ios application"
                    title=""
                    loading="lazy"
                  />
                </picture>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
